import ContentMessage from './ContentMessage'

export default ContentMessage
